// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2nfIj","notes":"Notes_notes__1JRJf"};